import { curry, prop, map } from 'ramda';
import { Maybe as maybe } from 'ramda-fantasy';

// DOM Functional utilities

// getElement :: string -> Maybe Element
const getElement = selector => maybe( document.querySelector( selector ) );

// getElements :: string -> Maybe Array
const getElements = selector => maybe( document.querySelectorAll( selector ) );

// getElementId :: Maybe Element -> Maybe string
const getElementId = map( prop( 'id' ) );

// getElementText :: Maybe Element -> Maybe string
const getElementText = map( prop( 'innerHTML' ) );

// appendText :: Maybe Element -> string -> Maybe Element
const appendText = curry( ( maybeElement, text ) =>
	maybeElement.map( Element => Element.insertAdjacentHTML( 'beforeend', text ) )
);

// createElementFromHTML :: string -> Element
const createElementFromHTML = htmlString => {
  const div = document.createElement( 'div' );
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};

// insertAfter :: Maybe Element -> string -> Maybe Element
const insertAfter = ( maybeElement, html ) =>
	maybeElement.map( Element =>
		Element.parentNode.insertBefore( createElementFromHTML( html ), Element.nextSibling ) );

// getElementFromParent :: string -> Maybe Element -> Maybe Element
const getElementFromParent = curry( ( selector, maybeElement ) =>
	maybeElement.map( Element => Element.querySelector( selector ) )
);

// wrapInTags :: string -> string -> string -> string
const wrapInTags = curry( ( open, close, text ) => open + text + close );

// getElementWithoutStyle :: selector -> Maybe Element
const getElementWithoutStyle = selector => maybe(
	Array.from( document.querySelectorAll( selector ) )
		.filter( Element => Element.style.display !== 'none' )[0]
);

// String Functional utilities

// createIdFromString :: string -> Maybe string -> Maybe string
const prependString = curry( ( prefix, maybeString ) =>
	maybeString.map( string => prefix + string )
);

// Positioning ultilities

const getWindowPosition = ( parts, topPartFactor, bottomPartFactor ) => {
	const topOfWindow = $( window ).scrollTop();
	const windowPortions = window.innerHeight / parts;
	const windowTop = topOfWindow + ( windowPortions * topPartFactor );
	const windowBottom = topOfWindow + ( windowPortions * bottomPartFactor );

	return {
		top: windowTop,
		bottom: windowBottom,
	};
};

const getElementPosition = ( section ) => {
	const $section = $( section );
	const elementTop = $section.offset().top;
	const elementBottom = elementTop + $section.outerHeight();

	return {
		top: elementTop,
		bottom: elementBottom,
	};
};

const isSectionVisible = ( section ) => {
	const windowPosition = getWindowPosition( 6, 1, 5 );
	const sectionPosition = getElementPosition( section );

	// The section top position must be bigger then the window top position.
	// And the section top must be lower then the window bottom
	return ( sectionPosition.top > windowPosition.top && sectionPosition.top < windowPosition.bottom );
};

export default {
	getElement,
	getElements,
	getElementId,
	getElementText,
	appendText,
	insertAfter,
	wrapInTags,
	getElementFromParent,
	prependString,
	getElementWithoutStyle,
	isSectionVisible,
};
